const affixValues = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]

export const uColor = (cls) => {
  const parts = cls.split('-')
  if (parts.length < 3) return cls

  const [prefix, color, value] = parts
  const index = affixValues.indexOf(Number(value))
  const invertedIndex = affixValues.length - index - 1
  return `${cls} dark:${prefix}-${color}-${affixValues[invertedIndex]}`
}
